import React from 'react';
import { Tooltip } from 'antd';
import { getRichTextOverlayRoot } from '../utils/overlayRoot';
import styles from './ToolbarTooltip.module.css';

export type ShortcutToken = 'mod' | 'shift' | 'alt' | string;

export const isMac =
  typeof navigator !== 'undefined' && /mac/i.test(navigator.platform);

const SYMBOL_MAP: Record<string, string> = {
  mod: isMac ? '⌘' : 'Ctrl',
  shift: '⇧',
  alt: isMac ? '⌥' : 'Alt'
};

export const renderShortcutToken = (token: ShortcutToken) =>
  SYMBOL_MAP[token] ?? token.toUpperCase();

export const ShortcutKeys = ({
  shortcut,
  keyClassName
}: {
  shortcut: ShortcutToken[];
  keyClassName?: string;
}) => (
  <span className={styles.shortcut}>
    {shortcut.map((token, index) => (
      <span key={`${token}-${index}`} className={keyClassName ?? styles.shortcutKey}>
        {renderShortcutToken(token)}
      </span>
    ))}
  </span>
);

export const ToolbarTooltip = ({
  label,
  shortcut,
  children
}: {
  label: string;
  shortcut?: ShortcutToken[];
  children: React.ReactElement;
}) => (
  <Tooltip
    title={
      <span className={styles.shortcutBubble}>
        {label}
        {shortcut && shortcut.length > 0 && <ShortcutKeys shortcut={shortcut} />}
      </span>
    }
    mouseEnterDelay={0.4}
    overlayStyle={{ zIndex: 2147483001 }}
    getPopupContainer={triggerNode => getRichTextOverlayRoot(triggerNode)}
  >
    {children}
  </Tooltip>
);

export default ToolbarTooltip;
